import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';
import { NgxEchartsModule } from 'ngx-echarts';
import { ButtonToggleSelectModule, CalendarPickerModule, KeyValueBlockModule } from 'ngx-zcs-components';

import { HeatpumpEnergyAggregationComponent } from './heatpump-energy-aggregation.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    HeatpumpEnergyAggregationComponent,
  ],
  imports: [
    BlockTitleComponent,
    ButtonToggleSelectModule,
    CalendarPickerModule,
    CommonModule,
    IonicModule,
    KeyValueBlockModule,
    MatIconModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
  ],
  exports: [
    HeatpumpEnergyAggregationComponent,
  ],
})
export class HeatpumpEnergyAggregationModule { }
